<template>
  <a-drawer
    :title="`${dramaDetail?.name || ''}（${detail?.type2target_text || ''}）`"
    width="600"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="onClose"
  >
    <!-- form -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 油管频道 -->
      <a-form-item
        label="油管频道"
        name="channel_id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          showSearch
          :filterOption="filterOption"
          v-model:value="formState.channel_id"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in channelList"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 标题 -->
      <a-form-item
        label="标题"
        name="title"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.title"
          placeholder="请输入"
        />
      </a-form-item>
      
      <!-- 公开日期 -->
      <a-form-item
        label="公开日期"
        name="publish_date"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-date-picker
          v-model:value="formState.publish_date"
          placeholder="请选择"
          style="width: 100%"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { reactive, ref, nextTick, h } from 'vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { MediaTypes, AudienceTypes } from '@/utils/constantList'
import { message, Modal } from 'ant-design-vue'
import dayjs from 'dayjs'
// 引入 API
import { ytSendYoutube, langSearchList, ytAccountAll } from '@/api/admin'

// emit
const emit = defineEmits(['success'])
// form
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 油管频道列表
let channelList= ref([])
// 修改对象
let detail = ref(null)
// 剧详情
let dramaDetail = ref(null)

// {
//   "task_id": 1,
//   "channel_id": "UCNSuHoXFQughnRRGV-7USdw",
//   "title":"eagle测试长视频-6",
//   "confirm":1,//默认不传，当返回data中message为：当前长视频已在该频道发布过，是否继续发布？这个时，用户确认后，传1
//   "publish_date": "2026-01-20" 
// }
// 表单参数
const formState = ref({
  // 油管频道
  channel_id: undefined,
  // 标题
  title: undefined,
  // 公开日期（YYYY-MM-DD）
  publish_date: undefined,
})

// 显示弹窗
function showDrawer(record, drama) {
  visible.value = true
  detail.value = record
  dramaDetail.value = drama

  // 如果有记录数据，则为编辑模式，填充表单
  if (record && record.id) {
    nextTick(() => {
      formState.value = {
        channel_id: record.channel_id,
        title: record.title,
        publish_date: record.publish_date ? dayjs(record.publish_date) : undefined,
      }
    })
  } else {
    // 新建模式，重置表单
    nextTick(() => {
      formState.value = {
        channel_id: undefined,
        title: undefined,
        publish_date: undefined,
      }
    })
  }
  // 获取选择项
  getSelectList()
}

// 获取选择项
function getSelectList() {
  // 油管频道列表
  ytAccountAll({ task_id: detail.value && detail.value.id }).then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      channelList.value = data
    }
  })
}

// 关闭弹窗
function onClose() {
  visible.value = false
  // 重置表单
  RefForm.value?.resetFields()
  formState.value = {
    channel_id: undefined,
    title: undefined,
    publish_date: undefined,
  }
  detail.value = null
  dramaDetail.value = null
}

// 提交
function touchSubmit() {
  RefForm.value.validate().then((res) => {
    // 上传数据
    const params = {
      confirm: 0,
      task_id: detail.value && detail.value.id,
      ...formState.value,
      // 格式化时间，将dayjs对象转换为YYYY-MM-DD字符串
      publish_date: formState.value.publish_date ? dayjs(formState.value.publish_date).format('YYYY-MM-DD') : undefined
    }
    submitPublish(params)
  }).catch((err) => {
    console.log(err)
  })
}

// 执行发布
function submitPublish(params) {
  isLoading.value = true
  ytSendYoutube(params).then((res) => {
    isLoading.value = false
    if (res.code === 0) {
      message.success('提交成功，发布时间大概需要30分钟左右')
      onClose()
      emit('success')
    } else if (res.code === -2) {
      // 显示二次确认对话框
      Modal.confirm({
        // title: '当前长视频已在该频道发布过噢',
        title: res.message,
        content: '你确定需要再发布一次吗?',
        okText: '确定',
        cancelText: '再想想',
        onOk() {
          // 用户确认后，重新调用接口并传递 confirm: 1
          const confirmParams = {
            ...params,
            confirm: 1
          }
          submitPublish(confirmParams)
        }
      })
    } else if (res.code === -3) {
      // 显示二次确认对话框
      Modal.confirm({
        // title: '当前长视频已在该频道发布过噢',
        title: res.message,
        okText: '知道了',
        cancelButtonProps: { style: { display: 'none' } }
      })
    } else {
      message.error(res.message)
    }
  }).catch(() => {
    isLoading.value = false
    message.error('提交失败')
  })
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 暴露方法给父组件
defineExpose({
  showDrawer
})
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>
